export default "__VITE_ASSET__KFDf5RP5__"